module.exports = __webpack_public_path__ + "img/SC2-Disclaimer.ebe9d874.png";